<template>
  <div class="page-container ">
    <div class="container-xl py-40 px-3 px-xl-0">
      <h2 class="pt-3 pb-5 fw-medium">Découvrez toutes les marques automobiles en un coup d’oeil</h2>
      <div class="list-marks "> 
          <div class="pt-14 pb-5" v-for="(marks,index) in listMarks" :key="index">
            <h3 class="marksParent fsz-18 text-gray-500 pb-32">{{ marks.parent }}</h3>
            <div class="d-flex flex-wrap ">
              <div class="item d-flex align-items-center col-12 col-sm-5 col-lg-2 pb-3 mb-3" v-for="(item,index) in marks.items" :key="index">
                <span class="material-symbols-rounded fsz-20 me-2 text-gray-900">chevron_right</span> 
                <NuxtLink 
                :to=" {path : '/voitures'  , query : {makes : item.make}}" 
                  class="text-primary-700 fsz-14 fw-medium">
                  {{ item.make }}
                </NuxtLink>  
              </div>
              
            </div>
            
          </div>
      </div>
  </div>
  </div>
    
</template>

<script setup lang="ts">
const runTimeConfig = useRuntimeConfig();
const listMarks = ref();
const route = useRoute();

definePageMeta({
  layout: "marques-voiture-layout",
});

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Marques de voitures en Tunisie - TopAuto`;
const seoDescription = `Découvrez toutes les marques automobiles disponibles en Tunisie. Explorez les voitures d'occasion par marque et trouvez votre véhicule idéal.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

const fetchListMarks = async () => {
  try {
    const response = await $fetch(
        "/makes/group-all",
        {
          method: "GET",
          
          
          baseURL: runTimeConfig.public.baseUrl,
        }
      );
      listMarks.value = response; 
    // console.log(listMarks.value);
  } catch (e) {
    console.error(e);
  }
};

onBeforeMount(() => {
  fetchListMarks();
});
</script>

<style scoped>

</style>